"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var ImageIcon_1 = require("./ImageIcon");
var Image_styles_1 = __importDefault(require("./Image.styles"));
function Image(_a) {
    var className = _a.className, themeOverride = _a.themeOverride, alt = _a.alt, src = _a.src, _b = _a.fit, fit = _b === void 0 ? 'cover' : _b, _c = _a.width, width = _c === void 0 ? '100%' : _c, _d = _a.height, height = _d === void 0 ? 'auto' : _d, _e = _a.radius, radius = _e === void 0 ? 0 : _e, style = _a.style, imageProps = _a.imageProps, _f = _a.withPlaceholder, withPlaceholder = _f === void 0 ? false : _f, placeholder = _a.placeholder, imageRef = _a.imageRef, elementRef = _a.elementRef, others = __rest(_a, ["className", "themeOverride", "alt", "src", "fit", "width", "height", "radius", "style", "imageProps", "withPlaceholder", "placeholder", "imageRef", "elementRef"]);
    var classes = Image_styles_1.default({ radius: radius, theme: theme_1.useMantineTheme(themeOverride) });
    var _g = react_1.useState(false), loaded = _g[0], setLoaded = _g[1];
    var _h = react_1.useState(!src), error = _h[0], setError = _h[1];
    var isPlaceholder = withPlaceholder && (!loaded || error);
    var firstUpdate = react_1.useRef(true);
    react_1.useEffect(function () {
        if (firstUpdate.current) {
            firstUpdate.current = false;
        }
        else {
            setLoaded(false);
            setError(false);
        }
    }, [src]);
    return (react_1.default.createElement("div", __assign({ "data-mantine-image": true, className: clsx_1.default(classes.wrapper, className), style: __assign({ width: width, height: height }, style), ref: elementRef }, others),
        isPlaceholder && (react_1.default.createElement("div", { "data-mantine-image-placeholder": true, className: classes.placeholderIcon, title: alt }, placeholder || react_1.default.createElement(ImageIcon_1.ImageIcon, { style: { width: 40, height: 40 } }))),
        react_1.default.createElement("img", __assign({ className: clsx_1.default(classes.image, imageProps === null || imageProps === void 0 ? void 0 : imageProps.className), src: src, alt: alt, style: __assign(__assign({}, imageProps === null || imageProps === void 0 ? void 0 : imageProps.style), { objectFit: fit }), ref: imageRef, onLoad: function (event) {
                setLoaded(true);
                typeof (imageProps === null || imageProps === void 0 ? void 0 : imageProps.onLoad) === 'function' && imageProps.onLoad(event);
            }, onError: function (event) {
                setError(true);
                typeof (imageProps === null || imageProps === void 0 ? void 0 : imageProps.onError) === 'function' && imageProps.onError(event);
            } }, imageProps))));
}
exports.Image = Image;
Image.displayName = '@mantine/core/Image';
